import {
	GetBulkChangeItemsResponse,
	GetPartsBulkChangeItemsResponse,
	GetSupplierBulkChangeItemsResponse,
} from "@/main/models/response";
import { IPartCancel, IPartCancelWithSupplier, IProcurementCancel, ISupplierCancel } from "./types";
import { IFormValues } from "./modalBulkCancelClaim";

function agroupPartsBySupplier(procurements: IProcurementCancel[]): ISupplierCancel[] {
	const suppliers = procurements.flatMap((procurement) => procurement.supplierPartsUpdateables);

	const agroupedSupplier = suppliers.reduce((acc, supplier) => {
		const supplierFound = acc.find((accSupplier) => accSupplier.guidSupplier === supplier.guidSupplier);
		if (supplierFound) {
			supplierFound.updateableParts = [...supplierFound.updateableParts, ...supplier.updateableParts];
		} else {
			acc.push(supplier);
		}
		return acc;
	}, [] as ISupplierCancel[]);
	return agroupedSupplier;
}

function mapBackendToFrontendCancelClaim(response: GetBulkChangeItemsResponse): IProcurementCancel {
	const formatSupplier = (supplier: GetSupplierBulkChangeItemsResponse): ISupplierCancel => {
		const formatPart = (part: GetPartsBulkChangeItemsResponse): IPartCancel => ({
			...part,
			guidProcurement: response.guidProcurement,
			guidProcurementSupplierItem: part.guidProcurementSupplierItem,
			guidProcurementSupplier: supplier.guidProcurementSupplier,
			deliveryBySupplier: Boolean(supplier.deliveryBySupplier),
			isSelected: true,
		});

		return {
			...supplier,
			reason: null,
			reasonDescription: "",
			isSelectedAll: true,
			guidProcurement: response.guidProcurement,
			updateableParts: supplier.updateableParts.map(formatPart),
		};
	};

	return {
		...response,
		isSelectedAll: true,
		supplierPartsUpdateables: response.supplierPartsUpdateables.map(formatSupplier),
	};
}

export function backendToFrontendCancelClaim(response: GetBulkChangeItemsResponse[]): ISupplierCancel[] {
	const formattedeProcurement = response.map(mapBackendToFrontendCancelClaim);
	const agroupedSupplier = agroupPartsBySupplier(formattedeProcurement);

	return agroupedSupplier;
}

export const getNameFormPart = (name: keyof IPartCancel, indexSupplier: number, indexPart: number) =>
	`suppliers.${indexSupplier}.updateableParts.${indexPart}.${name}` as const;

export const getNameFormSupplier = (name: keyof ISupplierCancel, indexSupplier: number) =>
	`suppliers.${indexSupplier}.${name}` as const;

export const getAllPartsForm = (data: IFormValues): IPartCancel[] =>
	data.suppliers.flatMap((supplier) => supplier.updateableParts.filter((i) => i.isSelected));
export const getAllPartsFormWithSupplier = (data: IFormValues): IPartCancelWithSupplier[] => {
	const allParts = data.suppliers.flatMap((supplier, indexSupplier) =>
		supplier.updateableParts.map((part, indexPart) => ({
			...part,
			supplier,
			indexSupplier,
			indexPart,
		})),
	);
	return allParts.filter((i) => i.isSelected);
};
